import { PasswordSimilarityRequestModel } from "@data-types/membership/registration";
import { httpClient } from "@utils";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";
import { ApiRequestContextData } from "@utils/api-config/types";

class PlatformPasswordAvailabilityApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/agency-user-passwords`;
	}

	static getRequestHeaders = (
		options: ApiRequestContextData = getApiRequestContext()
	) => {
		const appHeaders = getApplicationRequestHeaders(options);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static checkPasswordSimilarity(
		body: PasswordSimilarityRequestModel
	): Promise<boolean> {
		return httpClient.post(
			`${this.baseUrl}/password-similarity`,
			JSON.stringify(body),
			this.getRequestHeaders()
		);
	}
}

export default PlatformPasswordAvailabilityApiService;
